/** The popover's corner: the launcher's 2rem corner from sm up, so the panel
 * grows out of the spot the launcher leaves; respect phone safe areas. */
export const PLAYER_AI_FLOATING_PLACEMENT =
  "[--playerai-edge:0.75rem] sm:[--playerai-edge:2rem] [--playerai-bottom:max(var(--playerai-edge),env(safe-area-inset-bottom))] bottom-(--playerai-bottom) end-(--playerai-edge)";
